import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { allowMobileKey } from '../helpers/Constants';

const useCheckMobile = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [params, _] = useSearchParams();
  const enableMobile = params.get(allowMobileKey) === 'true';
  const [width, setWidth] = useState(window.innerWidth);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  if (enableMobile) {
    return { isMobileSize: false };
  }

  return { isMobileSize: width <= 500 };
};

export default useCheckMobile;
